module.exports = __webpack_public_path__ + "static/img/jiaotong-6.fbffa3f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/jiaotong/jiaotong-6.png
// module id = EtbC
// module chunks = 1